function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7969 8.71289C16.7969 13.2692 13.1032 16.9629 8.54688 16.9629C3.99053 16.9629 0.296875 13.2692 0.296875 8.71289C0.296875 4.15654 3.99053 0.462891 8.54688 0.462891C13.1032 0.462891 16.7969 4.15654 16.7969 8.71289Z",
  fill: "#4290F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2969 8.71289C16.2969 12.9931 12.8271 16.4629 8.54688 16.4629C4.26667 16.4629 0.796875 12.9931 0.796875 8.71289C0.796875 4.43268 4.26667 0.962891 8.54688 0.962891C12.8271 0.962891 16.2969 4.43268 16.2969 8.71289Z",
  stroke: "#4290F3",
  strokeOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5.54688,
  y: 5.71289,
  width: 6,
  height: 6,
  rx: 3,
  fill: "#EBF3FD"
});

function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.66fd283a.svg";
export { ForwardRef as ReactComponent };